export const DATA_SOURCE_CATEGORY_VALUE = 'security';
